// Default emoji categories for different use cases
export const TAG_EMOJI_CATEGORIES = {
  'General': ['🏷️', '⭐', '❤️', '💚', '💙', '💛', '💜', '🧡', '🖤', '🤍', '💖', '✨', '🔥', '💯', '✅', '❌', '⚠️', '🚫', '💡', '📌','‼️','🚨','🔔','🔕','☣️','🐘','📦','🤥','💉','💊','🎭','🏆','🛡️'],
  'Colors': ['🔴', '🟠', '🟡', '🟢', '🟣', '🟤', '⚫', '⚪', '🟦', '🟧', '🟨', '🟩', '🟪', '🟫', '🟥', '🟧', '🟨', '🟩', '🟪', '🟫'],
  'Vegetables': ['🥗', '🥕', '🍅', '🧄', '🌶️', '🥑', '🥦', '🥬', '🥒', '🌽', '🍆', '🥔', '🍄', '🫑', '🧅', '🥭', '🫚', '🫛', '🌿', '🍃'],
  'Fruits': ['🫐', '🍓', '🍌', '🍎', '🥥', '🍊', '🍋', '🍈', '🍉', '🍇', '🍑', '🍒', '🍍', '🥝', '🍐', '🫒', '🍏', '🥭', '🍁', '🍂'],
  'Proteins': ['🍖', '🥓', '🍗', '🐟', '🦐', '🥚', '🦀', '🦑', '🦪', '🍤', '🐙', '🦞', '🐠', '🐡', '🦈', '🐊', '🦆', '🦃', '🐓', '🥩'],
  'Dairy': ['🥛', '🧀', '🧈', '🍦', '🍨', '🧊', '🥛', '🍶', '🍼', '🥛'],
  'Grains': ['🍞', '🥖', '🥐', '🥨', '🍚', '🌾', '🍘', '🍙', '🥯', '🧇'],
  'Prepared Foods': ['🍝', '🥘', '🍲', '🥟', '🍕', '🌮', '🥪', '🍔', '🍟', '🌭', '🍛', '🍜', '🍣', '🍱', '🥡', '🍢', '🥧', '🥫', '🍥', '🍡'],
  'Sweets': ['🍰', '🧁', '🍪', '🍫', '🍬', '🍭', '🍮', '🍩', '🎂', '🍯', '🍧', '🍨', '🍦', '🥮', '🥠', '🍢', '🍡', '🍥', '🍘', '🍙'],
  'Beverages': ['☕', '🧃', '🥤', '🍷', '🍺', '🫖', '🍵', '🧋', '🍾', '🥃', '🍸', '🍹', '🍻', '🥂', '🫗', '🧉', '🥛', '💧', '🧊', '🥤'],
  'Misc Food': ['🥜', '🌰', '🫘', '🌱', '🥄', '🍴', '🥢', '🥡', '🍽️', '🔪', '🏺', '🫙', '🧂', '🌿', '🍃', '🌾', '🌰', '🥥', '🫚', '🫛'],
  'Health & Nutrition': ['💊', '💉', '🩺', '🧬', '🦴', '🫀', '🫁', '🧠', '🦷', '👁️', '💪', '🏃', '🧘', '🤸', '⚖️', '📊', '📈', '📉', '🎯', '✅'],
  'Activities': ['🏃', '🚴', '🏊', '🧘', '🤸', '⛹️', '🏋️', '🤼', '🤾', '🏌️', '🏄', '🏂', '⛷️', '🤺', '🏇', '🧗', '🚣', '🏃‍♀️', '🏃‍♂️', '💃'],
  'Emotions': ['😊', '😄', '😃', '😁', '😆', '😅', '😂', '🤣', '😇', '😉', '😍', '🥰', '😘', '😋', '😛', '😜', '🤪', '😎', '🤩', '🥳','🧐'],
  'Nature': ['🌿', '🍃', '🌱', '🌾', '🌻', '🌺', '🌸', '🌼', '🌵', '🌴', '🌳', '🌲', '🌹', '🥀', '🌷', '🌵', '🍀', '🍁', '🍂', '🍄'],
  'Weather': ['☀️', '🌤️', '⛅', '🌥️', '☁️', '🌦️', '🌧️', '⛈️', '🌩️', '🌨️', '❄️', '🌬️', '💨', '🌪️', '🌫️', '🌊', '💧', '☔', '⚡', '🔥']
};

export const CATEGORY_EMOJI_CATEGORIES = {
  'Food Categories': ['🍎', '🥬', '🥕', '🍅', '🥦', '🥒', '🌽', '🍆', '🥔', '🍄', '🥑', '🌶️', '🥭', '🍌', '🍇', '🍓', '🍒', '🍑', '🍍', '🥝'],
  'Proteins': ['🍖', '🥓', '🍗', '🐟', '🦐', '🥚', '🦀', '🦑', '🍤', '🥩', '🧀', '🥛', '🥯', '🍞', '🥖', '🥐', '🥨', '🧇', '🥞', '🧈'],
  'Prepared Foods': ['🍝', '🥘', '🍲', '🥟', '🍕', '🌮', '🥪', '🍔', '🍟', '🌭', '🍛', '🍜', '🍣', '🍱', '🥡', '🍢', '🥧', '🥫', '🍥', '🍡'],
  'Sweets & Desserts': ['🍰', '🧁', '🍪', '🍫', '🍬', '🍭', '🍮', '🍩', '🎂', '🍯', '🍧', '🍨', '🍦', '🥮', '🥠', '🍡', '🥧', '🍰', '🧁', '🍪'],
  'Beverages': ['☕', '🧃', '🥤', '🍷', '🍺', '🫖', '🍵', '🧋', '🍾', '🥃', '🍸', '🍹', '🍻', '🥂', '🫗', '🧉', '🥛', '💧', '🧊', '🥤'],
  'General': ['🏷️', '⭐', '❤️', '💚', '💙', '💛', '💜', '🧡', '🖤', '🤍', '💖', '✨', '🔥', '💯', '✅', '📦', '🎯', '🔔', '💡', '📌', '🏆'],
  'Colors': ['🔴', '🟠', '🟡', '🟢', '🟣', '🟤', '⚫', '⚪', '🟦', '🟧', '🟨', '🟩', '🟪', '🟫', '🟥', '🟧', '🟨', '🟩', '🟪', '🟫']
};

const emojiCategories = {
  TAG_EMOJI_CATEGORIES,
  CATEGORY_EMOJI_CATEGORIES
};

export default emojiCategories;